export var AppUpdateStatus;
(function (AppUpdateStatus) {
    AppUpdateStatus["NONE"] = "NONE";
    AppUpdateStatus["AVAILABLE"] = "AVAILABLE";
    AppUpdateStatus["REQUIRED"] = "REQUIRED";
})(AppUpdateStatus || (AppUpdateStatus = {}));
//# sourceMappingURL=app-settings.types.js.map